import { prefix, ajax } from './common';

export async function getProduct(id: number) {
  return await ajax({
    url: prefix + '/products/' + id,
  });
}

export async function getProductDetails(id: number) {
  return await ajax({
    url: prefix + '/products/' + id + '/details',
  });
}